import eventBus from '@/services/eventBus';

export default {
    props: {
        model: Object,
        submitFn: Function,
    },
    watch: {
        '$route.params.id': function (val) {
            this.load();
        },
        'model': {
            handler (val) {
                if (val && this.loadExtra) {
                    this.loadExtra();
                }
            },
            immediate: true,
        },
    },
    data () {
        return {
            editing: false,
        };
    },
    methods: {
        update (form) {
            return this.submitFn(form).then(() => {
                this.editing = false;
            });
        },
        load () {
            eventBus.emit('reload-data');
        },
    },
};
